import { render, staticRenderFns } from "./modalPayment.vue?vue&type=template&id=0a639e12"
import script from "./modalPayment.vue?vue&type=script&lang=js"
export * from "./modalPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports